import { isConsentRequiredIn, isAnalyticsDisabledIn } from '$lib/analytics/consent';
import { locationFromHeaders } from './location';

export function getUserContext() {
  if (typeof window === 'undefined') {
    throw Error('getUserContext must be called in the browser');
  }

  return window.__USER_CONTEXT__;
}

export function userContextFrom(headers: Headers): Window['__USER_CONTEXT__'] {
  const country = locationFromHeaders(headers) ?? '';

  return {
    analytics: {
      shouldRequestConsent: isConsentRequiredIn(country),
      isDisabled: isAnalyticsDisabledIn(country)
    }
  };
}
